import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Services from './components/Services';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Education from './components/Education';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/App.css';

function App() {
  const [theme, setTheme] = useState('dark');
  const [currentPhrase, setCurrentPhrase] = useState('');

  const phrases = ["Web Developer", "AI Developer", "Frontend Engineer", "Problem Solver", "Tech Enthusiast"];

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init('Odq-A2ns5VW9GrJL7');
  }, []);

  // Typing effect
  useEffect(() => {
    let pi = 0, ci = 0, forward = true;

    const tick = () => {
      const word = phrases[pi];

      if (forward) {
        ci++;
        setCurrentPhrase(word.slice(0, ci));
        if (ci === word.length) {
          forward = false;
          setTimeout(tick, 1200);
          return;
        }
      } else {
        ci--;
        setCurrentPhrase(word.slice(0, ci));
        if (ci === 0) {
          forward = true;
          pi = (pi + 1) % phrases.length;
        }
      }
      setTimeout(tick, forward ? 100 : 36);
    };

    tick();
  }, []);

  // Theme management
  useEffect(() => {
    const savedTheme = localStorage.getItem('pz_theme');
    if (savedTheme) setTheme(savedTheme);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('pz_theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <div className="App">
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <Hero currentPhrase={currentPhrase} />
      <About />
      <Skills />
      <Services />
      <Projects />
      <Experience />
      <Education />
      <Testimonials />
      <Contact />
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/923464969245"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#25D366',
          color: 'white',
          borderRadius: '50%',
          width: '56px',
          height: '56px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          zIndex: 1000,
          fontSize: '24px',
          cursor: 'pointer',
          transition: 'transform 0.2s'
        }}
        className="whatsapp-float"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
}

export default App;
